import React from "react";
import { ArrowUpRight } from "lucide-react";

function OtimizeSeuNegocio({ 
    text = "Otimize seu negócio!", 
    buttonText = "Contratar", 
    onClick,
    className = ""
}) {
    return (
        <div className={`mt-8 ${className}`}>
            <div className="relative rounded-[18px] p-[2px] bg-gradient-to-r from-[#4B3BDB] via-[#A002CB] to-[#FC0021] w-full md:w-fit">
                <div className="bg-[#2b283d] rounded-[16px] py-4 md:py-2 pl-6 pr-4 gap-8 flex items-center w-full md:w-fit justify-between md:justify-start">
                    <p className="text-[13px] md:text-xl font-inter-light text-white">
                        {text.includes(" ") ? (
                            <>
                                {text.split(" ")[0]}{" "}
                                <br className="hidden md:block" /> {text.split(" ").slice(1).join(" ")}
                            </>
                        ) : (
                            text
                        )}
                    </p>
                    <button
                        onClick={onClick}
                        className="font-poppins-light bg-white text-black flex items-center gap-2.5 rounded-full py-2 md:py-1 px-6 md:px-8 text-[11px] md:text-sm w-fit cursor-pointer hover:scale-105 transition-transform duration-200"
                    >
                        {buttonText}
                        <ArrowUpRight className="w-4 md:w-6 h-4 md:h-6" />
                    </button>
                </div>
            </div>
        </div>
    );
}

export default OtimizeSeuNegocio;
